(function() {
    "use strict";

    function uniqueId() {
        let length = 8;
        let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'.split('');
        let str = '';

        if (!length) {
            length = Math.floor(Math.random() * chars.length);
        }

        for (let i = 0; i < length; i++) {
            str += chars[Math.floor(Math.random() * chars.length)];
        }

        return str;
    }

    module.exports = uniqueId;
})();


// WEBPACK FOOTER //
// ./resources/scripts/utils/uniqueId.js